import React from "react";
import { deliverySteps } from "../../data/sections";
import { commerce } from "../../data/commerce";
import { deliveryText } from "../../utils/commerce";
import { SectionHeading } from "../ui/SectionHeading";
export function Delivery() {
  return <section id="entrega" aria-labelledby="entrega-title" className="scroll-mt-20 py-20 md:py-28" data-id="element-46" data-mp="3foc0vpztgthb">
      <div className="mx-auto max-w-5xl px-4 md:px-6" data-id="element-47" data-mp="3ap9751pae9on">
        <SectionHeading id="entrega-title" eyebrow="Entrega" title="Cómo accedés a tu megapack" data-id="element-48" data-mp="35sioq7q0f202" />
        <ol className="mt-12 grid gap-8 md:grid-cols-3" data-id="element-49" data-mp="30swbvze3fnrs">
          {deliverySteps.map((s, i) => <li key={s.title} className="flex gap-4 md:flex-col md:gap-0" data-id="element-50" data-mp="2wqss8nh9tcvf" data-mpi={i}>
              <span className="font-serif text-4xl text-dorado-deep" data-id="element-51" data-mp="2rsr77x0ab3hb">{i + 1}</span>
              <div className="md:mt-3" data-id="element-52" data-mp="v07i5712syol">
                <h3 className="text-lg font-semibold text-pizarra-deep" data-id="element-53" data-mp="uz65iy4ew44r">{s.title}</h3>
                <p className="mt-1 leading-relaxed text-pizarra-soft" data-id="element-54" data-mp="q0l26ptv54c3">{s.text}</p>
              </div>
            </li>)}
        </ol>
        <div className="mt-10 grid gap-4 rounded-3xl border border-pizarra/10 bg-papel/70 p-6 text-[15px] leading-relaxed text-pizarra md:grid-cols-2" data-id="element-55" data-mp="1f5ov4pjkpmue">
          <p data-id="element-56" data-mp="166v2195gbell">
            <span className="font-semibold text-pizarra-deep" data-id="element-57" data-mp="167d8szpqpb7r">Entrega: </span>
            {deliveryText()}
          </p>
          <p data-id="element-58" data-mp="1b5y90z4zruw7">
            <span className="font-semibold text-pizarra-deep" data-id="element-59" data-mp="1b5of50gtt3l8">Consultas: </span>
            {commerce.support.trim() || "El canal de consultas se informará antes de habilitar la compra."}
          </p>
        </div>
      </div>
    </section>;
}